import { Component, Input, OnInit } from '@angular/core';
import { MainNavigationService } from '../main-navigation.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-tea-item-summary',
  templateUrl: './tea-item-summary.component.html',
  styleUrls: ['./tea-item-summary.component.css'],
  standalone: false
})
export class TeaItemSummaryComponent implements OnInit {
  @Input({ required:true }) teaItem: any;

  constructor(
    private mainNavigationService: MainNavigationService,
    private logger: NGXLogger,
  ) { 
    this.teaItem = {
      name: 'Green Tea',
      price: 3.5,
      description: 'Green tea is a type of tea that is made from Camellia sinensis leaves and buds that have not undergone the same withering and oxidation process used to make oolong teas and black teas.'
    };
  }

  ngOnInit() {
    this.mainNavigationService.getTeaItemProduct(this.teaItem.slug).subscribe({
      next: (teaItem) => {
        this.teaItem = teaItem;
        const teaItemProductImages = teaItem.teaItemProductImages;
        // Choose the teaItemProductImage with the lowest position
        const teaItemProductImage = teaItemProductImages.reduce((prev: any, current: any) => (prev.position < current.position) ? prev : current);
        this.teaItem.imageURL = teaItemProductImage.url;
      },
      error: (error) => {
        this.logger.error('An error occurred while retrieving the tea item:', error);
      },
    });
  }
}
